import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-gender',
  standalone: true,
  templateUrl: './gender.component.html',
  styleUrls: ['./gender.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenderComponent),
      multi: true,
    },
  ],
})
export class GenderComponent implements ControlValueAccessor {
  selectedGender: string = 'unspecified';

  onChange = (selectedGender: string) => {};
  onTouched = () => {};
  touched = false;
  disabled = false;

  constructor() {}

  onChanged(event: any): void {
    this.selectedGender = event.target.value;
    this.onChange(this.selectedGender);
  }

  writeValue(value: any) {
    this.selectedGender = value;
  }
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
